export default __webpack_public_path__ + "static/rovo-menu-dark-c7b20305e1a281cc0ae16a0d349ae11ad09d98f2bf7b2dc08684bc315c5d3791.png";